import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
  mutation PayWithAmazonMutation($input: PayWithAmazonInput!) {
    payWithAmazon(input: $input) {
      order {
        id
        orderid
        state
      }
    }
  }
`;

function commit(environment, orderId, sessionId, callback) {
  return commitMutation(environment, {
    mutation,
    variables: {
      input: {
        orderId,
        sessionId
      },
    },
    onCompleted: (response, errors) => {
      if (errors) {
        callback && callback(errors[0]);
      } else {
        callback && callback(null, response.payWithAmazon.order);
      }
    },
    onError: err => {
      callback && callback(err);
    },
  });
}

export default { commit };
